<template>
    <div>
        <h2 class="mb-3" v-html="$t('intern_invoices.topic')"></h2>

        <div class=" pt-4 pb-4">
          <div class="row ">
            <div class="col-md-5 pb-2">
              <div class="form-group position-relative">
                <input type="text" class="form-control" name="invoiceNr" v-model="invoice_nr" placeholder="Nach Rechnungsnummer suchen" v-on:keyup.enter="fetchInvoices()" />
                <font-awesome-icon icon="search" class="search mm-color" @click="fetchInvoices()"/>
              </div>
            </div>
            <div class="col-md-7 pb-2">
              <div class="input-group">
                <label class="input-group-text font-weight-bold ">Jahr </label>
                <select v-model="year" @change="fetchInvoices()" class="form-select form-control ">
                    <option value="0">Jahr wählen</option>
                    <option :value="year" v-for="(year, index) in years" :key="index">{{year}}</option>
                </select>
                <label class="input-group-text font-weight-bold ">Monat </label>
                <select v-model="month" @change="fetchInvoices()" class=" form-select form-control ">
                    <option value="0">Monat wählen</option>
                    <option  v-for="(month ,index ) in months" :key="index" :value="month">{{month}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-5 pb-2">
              <select v-model="sort" @change="fetchInvoices()" class=" form-control">
                <option value="Neueste Rechnungen"> Sortieren: Neueste zuerst </option>
                <option class="font-weight-bold" value="Älteste Rechnungen" >Sortieren: Älteste zuerst</option>
              </select>
            </div>
            <div v-if="isFilterApplied" class="col-md-7 pb-2">
              <input type="button" class="btn btn-danger float-right" value="Filter löschen" @click="removeFilters()"/>
            </div>
          </div>
        </div>

        <div v-if="isMobile">
            <!--<select v-model="year" @change="fetchInvoices()" class="form-control mb-3">
                <option value="0">Jahr wählen</option>
                <option :value="currentYear - index" v-for="(n, index) in 15" :key="index">{{currentYear - index}}</option>
            </select>-->
            <div v-if="invoices.length > 0">
                <div v-for="invoice in invoices" :key="invoice.id" class="card mb-3">
                    <div class="card-header">
                        <div class="card-title">
                            {{$t('intern_invoices.no')}}<br>{{invoice.rechnungsnummer}}
                        </div>
                    </div>
                    <div class="card-body">
                        <div><strong style="display: inline-block;width:170px;">{{$t('intern_invoices.date')}}</strong>{{invoice.date}}</div>
                        <div><strong style="display: inline-block;width:170px;">{{$t('intern_invoices.brutto')}}</strong>{{invoice.total_brutto | currency}}</div>
                        <div><strong style="display: inline-block;width:170px;">{{$t('intern_invoices.netto')}}</strong>{{invoice.total_netto | currency}}</div>
                        <div class="text-center mt-3">
                            <a :href="'/api/invoiceApi/showInvoice?id=' + invoice.id" target="_blank" class="btn btn-success">{{$t('intern_invoices.show')}}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="alert alert-warning" colspan="5">Sie haben entwieder in diesem Zeitraum oder überhaupt keine Rechnungen
            </div>
        </div>

        <table class="table table-striped font-13" v-else>
            <thead>
                <tr>
                    <th>{{$t('intern_invoices.no')}}</th>
                    <th>{{$t('intern_invoices.netto')}}</th>
                    <th>{{$t('intern_invoices.brutto')}}</th>
                    <th>{{$t('intern_invoices.date')}}</th>
                    <th class="p-0" style="vertical-align: middle"></th>
                </tr>
            </thead>
            <tbody v-if="invoices.length > 0">
                <tr v-for="invoice in invoices" :key="invoice.id">
                    <td>{{invoice.rechnungsnummer}}</td>
                    <td>{{invoice.total_netto | currency}}</td>
                    <td>{{invoice.total_brutto | currency}}</td>
                    <td>{{invoice.date}}</td>
                    <td><a :href="'/api/invoiceApi/showInvoice?id=' + invoice.id" target="_blank" class="text-dark" style="text-decoration: underline">{{$t('intern_invoices.show')}}</a></td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td class="alert alert-warning" colspan="5">{{$t('intern_invoices.keine_rechung')}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import { IsMobileMixin } from '../../mixins/IsMobile';

    export default {
        name: 'konto-rechnungen',
        data() {
            return {
                currentYear: new Date().getFullYear(),
                currentMonth : new Date().getMonth(),
                year: 0,
                month: 0,
                sort: 'Neueste Rechnungen',
                invoice_nr : '',
                invoices: [],
                months : ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
                years : [],
                isFilterApplied : false
            }
        },
        mixins: [IsMobileMixin],
        methods: {
            fetchInvoices() {
                this.$store.state.loading = true;
                if(this.year == "0" && (this.months.indexOf(this.month) + 1) == "0" && this.sort == "Neueste Rechnungen" && this.invoice_nr == ""){
                  this.isFilterApplied = false;
                }
                else{
                  this.isFilterApplied = true;
                }

                this.$http.get('/userApi/allInvoices', {
                    params: {
                      year: this.year,
                      month: (this.months.indexOf(this.month) + 1),
                      sort : this.sort,
                      invoice_nr : this.invoice_nr
                    }
                }).then(response => {
                    this.invoices = [];
                    const data = JSON.parse(response.data);
                    const invoices = data.invoices;

                    for(const inv of invoices){
                        this.invoices.push(JSON.parse(inv));
                    }
                    this.extractYearsfromAvailableInvoices();
                    this.$store.state.loading = false;

                }).catch(error => {
                    console.log(error);
                })
            },
            removeFilters(){
              this.year = 0;
              this.month = this.months.indexOf(0) + 1;
              this.sort = "Neueste Rechnungen";
              this.invoice_nr = "";
              this.fetchInvoices();
            },
            extractYearsfromAvailableInvoices(){
              this.invoices.forEach(invoice => {
                if(!this.years.includes(invoice.date.substring(invoice.date.lastIndexOf(".") + 1)) ) {
                  this.years.push(invoice.date.substring(invoice.date.lastIndexOf(".") + 1));
                  this.years.sort(function(a, b){return b-a});
                }
              })
            }
        },
        created() {
            document.title = 'Meine Rechnungen';
            this.fetchInvoices();
        },
    }
</script>

<style scoped>
.input-group-text{
  border : 1px solid #808080 !important;
}
.form-control{
  border : 2.3px solid #808080 !important;
  border-radius: 5px !important;
}
.search{
    width: 15px;
    height: 15px;
    position: absolute;
    top: 12px;
    right: 10px;
    cursor: pointer;
}
</style>
